
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Box, Dialog, DialogContent } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { columns, EXCLUDE_KEYS, formatValue } from "./columns"





const LogTableDialog = ({ tableName, idColNm, idValue, excludeKeys, colNm, title, dialogOpen, setDialogOpen }) => {
  const { ax } = useContext(GlobalStateContext)
  const [rows, setRows] = useState([])

  useEffect(() => {
    console.log("LogTableDialog useEffect", { dialogOpen, tableName, idColNm, idValue, colNm, excludeKeys, ax })
    if(dialogOpen){
      ax.post("/core/getTableLog", { TableNm: tableName, IdColNm: idColNm, IdValue: idValue }).then(value => {
        if (value.data) {
          const data = value.data
          // rows sorted ASC — data[i-1] is the previous version in time
          const mapped = data.map((row, i) => {
            const prev = data[i - 1] // undefined for oldest row (i=0)
            const diff = {}
            for (const key of Object.keys(row)) {
              if (EXCLUDE_KEYS.has(key) || (excludeKeys && excludeKeys.includes(key))) continue
              const label = colNm?.[key] || key
              const curVal = formatValue(row[key])
              if (!prev) {
                diff[label] = curVal
              } else {
                const prevVal = formatValue(prev[key])
                if (String(curVal ?? "") !== String(prevVal ?? "")) {
                  diff[label] = `${prevVal ?? ""} → ${curVal ?? ""}`
                }
              }
            }
            return { ...row, id: i+1, No: i + 1, _diff: diff }
          })
          setRows(mapped)
        }
      })
    } else {
      setRows([])
    }
  }, [dialogOpen, tableName, idColNm, idValue, colNm, excludeKeys, ax])

  const columnsMemo = useMemo(() => columns(colNm), [colNm])
  const handleClose = useCallback(() => setDialogOpen(false), [setDialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="xl">
      <DialogHeader handleDialogClose={handleClose} title={title || "ประวัติการเปลี่ยนแปลงข้อมูล"} onDeleteClick={null} />
      <DialogContent>
        <BoxFC pt={2}>
          <Box height={450}>
            <DataGridCellExpand
              density="compact"
              hideFooter
              rows={rows}
              columns={columnsMemo}
            />
          </Box>
        </BoxFC>
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(LogTableDialog)
